import { ScreenOptionsManager } from '../../ScreenOptionsManager';

export const DemoSelectScreen = () => {
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <p className='interactions-text text-sm mb-3 font-bold'>Select Demo</p>
            <div className="w-[74%] flex flex-wrap justify-center p-y-2 gap-x-2 gap-y-2">
                <ScreenOptionsManager options={['Bellsn8ke: on Bellscoin', 'Astercoins: on Bitcoin']} />
            </div>
        </div>
    )
}
